const grey200Color = '#F4F5F5';

export default grey200Color;
